module.exports = __webpack_public_path__ + "static/Sanjeev_Kumar-0d407573712a14d343477b7edb7060c3.jpg";